if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: function(obj: object, prop: PropertyKey) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
    writable: true,
    configurable: true,
    enumerable: false
  });
}

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react"
import './index.css'
// i18n must be imported before App so translations are ready on first render
import './i18n/index'
import App from './App.tsx'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const rootElement = document.getElementById('root')!

// Force reload on resource loading errors (ChunkLoadError)
window.addEventListener('error', (event) => {
  if (event.message?.includes('chunk') || event.message?.includes('Loading chunk')) {
    console.warn('Chunk loading error detected. Forcing page refresh...')
    window.location.reload()
  }
}, true)

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
